import { paragraphSectionTemplateInitialValues } from './paragraphSectionTemplateInitialValues';
import { paragraphSectionTemplateInitialStatus as initialStatus } from './paragraphSectionTemplateInitialStatus';

export default {
  initialValues: paragraphSectionTemplateInitialValues,
  initialStatus,
};
